import { WebSocketStoreKeys } from 'clickNgo/configs/service/ws'
import { getUserRegion } from 'clickNgo/helpers/geo'
import { getAccessToken } from 'cng-common/helpers/access'
import WebSocketStore from 'core/classes/services/WebSocketStore'

import { mapFiltersToContactSearchParameters } from './helpers/mapFiltersToContactSearchParameters'
import { mapFiltersToPartnerSearchParameters } from './helpers/mapFiltersToPartnerSearchParameters'
import { ISearchFn } from './models/search'

export const search: ISearchFn = async ({ filters, user, countries }, type) => {
  const token = getAccessToken()
  const wsClient = WebSocketStore.get(WebSocketStoreKeys.Onboarding)

  const region = getUserRegion(user)
  const searchPayload =
    type === 'partners'
      ? mapFiltersToPartnerSearchParameters({ filters, region, countries })
      : mapFiltersToContactSearchParameters({ filters, region, countries })

  return await wsClient.call({
    service: 'search',
    action: type,
    payload: searchPayload,
    token: token || undefined,
    withoutTokenRefresh: true,
    isAuth: true,
    returnError: true,
  })
}
